<template>
  <svg
    aria-hidden="true"
    class="svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
  >
    <use :href="symbolId" :fill="color" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

defineOptions({
  name: "SvgIcon"
});

const {
  name,
  prefix = "icons",
  color = "currentColor"
} = defineProps<{
  name: string;
  prefix?: string;
  color?: string;
}>();

const symbolId = computed(() => `#svg-${prefix}-${name}`);
</script>

<style lang="scss">
.svg-icon {
  max-height: 1em;
  max-width: 1em;

  display: inline-block;
  overflow: visible;

  &--thicker {
    stroke-width: 5px;
    stroke: currentColor;
  }
}
</style>
